import {
  alpha,
  Divider,
  Stack,
  StackProps,
  Theme,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { ElementType } from "react";
import { Icon } from "../Icon";

export const OverlayDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.customColors.border,
  transform: "scaleX(0.6)"
}));

export const OverlayStack = styled(Stack)<
  Omit<
    StackProps,
    "component"
  > & {
    $commentModalOpen:boolean,
    component: ElementType
  }
>(({ $commentModalOpen, theme }) => ({
  cursor:"pointer",
  position: "absolute",
  right: theme.spacing(3),
  top: "50%",
  transform: "translateY(-50%)",
  width: "3rem",
  zIndex: $commentModalOpen ? "14050 !important" : "1150",

  [theme.breakpoints.down("sm")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    position: "static",
    transform: "none",
    width: "100%"
  }
}));

export const OverlayGroupStack = styled(Stack)<StackProps>(({ theme }) => ({
  borderRadius: theme.spacing(1),
  position: "relative",
  ">div":{
    //paddingInline: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      maxHeight: "100%",
      minWidth: "55px"
    }
  },

  "&::before": {
    backgroundColor: theme.customColors.backgroundPrimary,
    borderRadius: theme.spacing(1),
    boxShadow: `0.25rem 0.25rem 0.75rem ${theme.palette.common?.black && alpha(theme.palette.common?.black, 0.25)}`,
    content: "''",
    height: "100%",
    left: 0,
    position: "absolute",
    top: 0,
    width: "100%",
    zIndex: -1
  },

  [theme.breakpoints.down("sm")]: {
    alignItems: "center",
    backgroundColor: theme.customColors.backgroundPrimary,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    maxHeight: "48px",
    minHeight: "48px",
    paddingBlock: 0,
    position: "static",
    transform: "none",

    ">div":{
      paddingBlock: "10px",
      paddingInline:0
    },

    "&::before": {
      content: "none"
    },

    "& a": { margin: "auto" },

    "& a div": {
      flexDirection: "row"
    },

    "& :hover": {
      "path":{
        fill: theme.customColors.textPrimary,
        stroke: theme.customColors.textPrimary
      }
    }
  }
}));

export const OverlayTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "0.75rem"
}));

export const CtaOverlayIcon = styled(Icon)(({ icon, theme }:{icon:string, color?: string, theme: Theme}) => ({
  "&":
    {
      "&.withpadding": {
        width: "100% !important",
        height: "44px !important",
        padding: "12px",
        [theme.breakpoints.down(769)]: {
          padding: "4px"
        }
      },
      "&.onhover_ctaoverlay:hover":{
        "path":{
          fill: theme.customColors.textPrimary,
          stroke: theme.customColors.textPrimary,
          transform:
          icon === "Icons_rating_active"
            ? "scale(1.2) translate(-190px, -190px)"
            : icon ===
            "Star3-5" ? "scale(1.2) translate(-170px, -190px)" :
              icon === "Icons_salva-preferito_glow" ?
                "scale(1.2) translate(-50px, -50px)"
                : undefined
        }
      },
      /*"&.star": {
        marginTop: "10px"
      },*/
      "&.star svg": {
        marginTop: "5px"
      },
      "path":
      {
        fill: theme.customColors.textPrimary,
        stroke: theme.customColors.textPrimary,
        transform:
          icon === "Icons_rating_active"
            ? "scale(1.2) translate(-190px, -190px)"
            : icon ===
            "Star3-5" ? "scale(1.2) translate(-170px, -190px)" :
              icon === "Icons_salva-preferito_glow" ?
                "scale(1.2) translate(-50px, -50px)"
                : undefined
      }
    }
}));
